import React, { useEffect, useState } from "react";
import { animalAssets, mainAssets } from "../services/constant";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import { PhoneCallbackOutlined } from "@mui/icons-material";
import { MailOutlineOutlined } from "@mui/icons-material";
import { ExpandMoreOutlined } from "@mui/icons-material";
import { Logout } from "../services/utils";
import MemberModal from "./memberModal";
export default function Header({ entitylist, entity, setEntity }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorElUser, setAnchorElUser] = useState(null);
    const [anchorElList, setAnchorElList] = useState(null);
    const [showMember, setShowMember] = useState(false);
    const userData = JSON.parse(localStorage.getItem('userData'));

    const popUpHelp = (e) => {
        setAnchorEl(e.currentTarget);
    };
    const handleCloseHelp = () => {
        setAnchorEl(null);
    };

    const popUpUser = (e) => {
        setAnchorElUser(e.currentTarget);
    };
    const handleCloseUser = () => {
        setAnchorElUser(null);
    };

    const popUpList = (e) => {
        setAnchorElList(e.currentTarget);
    };
    const handleCloseList = () => {
        setAnchorElList(null);
    };

    const onChange = (item) => {
        handleCloseList();
        localStorage.setItem("entity_id", item.id);
        setEntity(item.name);
    };
    const addMember = () => {
        setShowMember(true);
        setAnchorElUser(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    const openUser = Boolean(anchorElUser);
    const idUser = openUser ? "simple-popover" : undefined;

    const openList = Boolean(anchorElList);
    const idList = openList ? "simple-popover" : undefined;


    return (
        <div className="header bg-color">
            <img src={animalAssets.logo} className="animal_logo" alt="" />
            <div className="flex-row mr-[2rem] gap-[1rem]">
                {entity !== "" ? (
                    <>
                        <button
                            className="btn_icon bg-color flex-row font-center"
                            onClick={(e) => popUpList(e)}
                        >
                            <img src={mainAssets.ic_home} alt="" />
                            <span className="ml-1  font-color font-center font-13-500">
                                {entity}
                            </span>
                            <ExpandMoreOutlined sx={{ fontSize: "19px" }} />
                        </button>
                        <Popover
                            id={idList}
                            open={openList}
                            anchorEl={anchorElList}
                            onClose={handleCloseList}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}
                            sx={{
                                "& .MuiPaper-root": {
                                    marginTop: "1.5rem",

                                    width: "fit-content",
                                    border: "1px solid #fff",
                                    borderRadius: "1.1rem",
                                    boxShadow: "0px 0px 23px 0px #00000026",
                                },
                            }}
                        >
                            <Typography
                                sx={{ padding: "1.5rem 2.0rem 1.5rem 1.9rem" }}
                            >
                                <div className="flex-colunm">
                                    {entitylist.elements.map((item, index) => {
                                        return (
                                            <div className="flex flex-col gap-4" key={index}>
                                                <button
                                                    className="font-13-500 font-left common-btn font-color btn-hover"
                                                    onClick={() =>
                                                        onChange(item)
                                                    }
                                                >
                                                    <span>{item.name}</span>
                                                </button>
                                            </div>
                                        );
                                    })}
                                </div>
                            </Typography>
                        </Popover>
                    </>
                ) : (
                    <div></div>
                )}
                <button className="btn_help" onClick={(e) => popUpHelp(e)}>
                    <img src={animalAssets.ic_help} alt="" />
                </button>
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleCloseHelp}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    sx={{
                        "& .MuiPaper-root": {
                            marginTop: "-2.1rem",
                            maxWidth: "24rem",
                            width: "100%",
                            border: "1px solid #fff",
                            borderRadius: "1.1rem",
                            boxShadow: "0px 0px 23px 0px #00000026",
                        },
                    }}
                >
                    <Typography sx={{ padding: "1.5rem 2.0rem 1.5rem 1.9rem" }}>
                        <div className="flex-colunm">
                            <div className="font-16-600 mb-1">
                                Em caso de dúvidas:
                            </div>
                            <div className="font-14-500 font-left">
                                <PhoneCallbackOutlined className="mr-1" /> 21
                                020 1238
                            </div>
                            <div className="font-14-500 font-left">
                                <MailOutlineOutlined className="mr-1" />{" "}
                                prestadores@medipet.pt
                            </div>
                        </div>
                    </Typography>
                </Popover>
                <button className="btn_icon" onClick={popUpUser}>
                    <img src={animalAssets.ic_user} alt="" />
                </button>
                <Popover
                    id={idUser}
                    open={openUser}
                    anchorEl={anchorElUser}
                    onClose={handleCloseUser}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    sx={{
                        "& .MuiPaper-root": {
                            marginTop: "-2.1rem",
                            maxWidth: "17rem",
                            width: "100%",
                            border: "1px solid #fff",
                            borderRadius: "1.1rem",
                            boxShadow: "0px 0px 23px 0px #00000026",
                        },
                    }}
                >
                    <Typography sx={{ padding: "1.5rem 2.0rem 1.5rem 1.9rem" }}>
                        <div className="flex-colunm">
                            {
                                userData?.roles[0] !== "PROVIDEROPERATOR" && (
                                    <button
                                        className="font-14-500 font-center common-btn"
                                        onClick={() => addMember()}
                                    >
                                        Membros da Equipa
                                    </button>
                                )
                            }
                            <button
                                className="font-14-500 font-center common-btn"
                                onClick={() => Logout()}
                            >
                                Terminar sessão
                            </button>
                        </div>
                    </Typography>
                </Popover>
            </div>
            <MemberModal
                showMember={showMember}
                setShowMember={setShowMember}
            />
        </div>
    );
}
